export const dataHooks = {
    button: 'sidebarsectionitem-button',
    title: 'sidebarsectionitem-title',
    prefix: 'sidebarsectionitem-prefix',
    suffix: 'sidebar-sub-menu-chevron',
};
export const skins = { dark: 'dark', light: 'light' };
//# sourceMappingURL=constants.js.map